import { getMySnippets } from '../../../../../helper/backendHelper'

export function getSnips(onSuccess = () => {}, sortFunction = (data) => data) {
  getMySnippets().then((res) => {
    if (res?.status === 'success') {
      onSuccess(sortFunction(res?.results))
    }
  })
}
